import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './components/NotificationProvider';
import StudentLogin from './components/StudentLogin';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import Dashboard from './components/Dashboard';
import ExamInstructions from './components/ExamInstructions';
import ExamInterface from './components/ExamInterface';
import AdminPanel from './components/AdminPanel';
import PlacementTest from './components/PlacementTest';
import PlacementResults from './components/PlacementResults';
import PlacementTestReview from './components/PlacementTestReview';
import PlacementAdmin from './components/PlacementAdmin';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
            {/* Login routes */}
            <Route path="/" element={<StudentLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            {/* Rutas protegidas para estudiantes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/exam/:examId/instructions" element={
              <ProtectedRoute>
                <ExamInstructions />
              </ProtectedRoute>
            } />
            <Route path="/exam/:examId/take" element={
              <ProtectedRoute>
                <ExamInterface />
              </ProtectedRoute>
            } />
            
            {/* Rutas de examen de ubicación */}
            <Route path="/placement/test" element={
              <ProtectedRoute>
                <PlacementTest />
              </ProtectedRoute>
            } />
            <Route path="/placement/results" element={
              <ProtectedRoute>
                <PlacementResults />
              </ProtectedRoute>
            } />
            <Route path="/placement/test/review" element={
              <ProtectedRoute>
                <PlacementTestReview />
              </ProtectedRoute>
            } />
            
            {/* Rutas protegidas para administradores */}
            <Route path="/admin" element={
              <ProtectedRoute requireAdmin>
                <AdminPanel />
              </ProtectedRoute>
            } />
            <Route path="/admin/placement" element={
              <ProtectedRoute requireAdmin>
                <PlacementAdmin />
              </ProtectedRoute>
            } />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;